import { styled } from '@mui/material/styles';
import { Container } from '@mui/material';

export const AppContainer = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4),
  // minHeight: 'calc(100vh - 64px)', // Adjust or remove based on your layout (e.g., if you have an AppBar)
  minHeight: '90vh', // Ensure it takes significant vertical space
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center', // Center the content horizontally within the container
}));

// Add any other shared styles for the WillGenerator scope here if needed
